import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d8bd632"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "live-search-result",
  "aria-live": "polite",
  class: "h-full overflow-x-hidden overflow-y-auto o-scrollbar mt-x2 pr-x1 pb-x4 mb-x2 list-none lg:pr-0"
}
const _hoisted_2 = {
  key: "showAllResults",
  class: "pt-x5 text-center"
}
const _hoisted_3 = {
  key: 0,
  class: "search-section text-center"
}

import { computed } from 'vue';
import SearchResultItems from '@/shared/search/ui/SearchResultItems.vue';
import SearchQuickLinks from '@/shared/search/ui/SearchQuickLinks.vue';
import SearchResultProducts from '@/shared/search/ui/SearchResultProducts.vue';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import useSearch from '@/shared/search/useSearch';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResult',
  setup(__props) {

const globalLabels = useGlobalLabels(GlobalLabels.search);
const { term, pending, result, searchPageLink } = useSearch();

const showCategoryLinks = computed(() => {
    return result.value && result.value.categories && result.value.categories.total > 0;
});

const showContentLinks = computed(() => {
    return result.value && result.value.content && result.value.content.total > 0;
});

const showProducts = computed(() => {
    return result.value && result.value.products && result.value.products.total > 0;
});

const showShowAllResultsButton = computed(() => {
    return (
        (result.value?.products.results?.length ?? false) || (result.value?.content.results?.length ?? false)
    );
});

const showNoResultText = computed(() => {
    return term.value && !pending.value && result.value && result.value.totalResults === 0;
});

const showQuickLinks = computed(() => {
    return !term.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createVNode(_Transition, { name: "o-anim-fade-200" }, {
        default: _withCtx(() => [
          (_unref(showCategoryLinks))
            ? (_openBlock(), _createBlock(SearchResultItems, {
                key: "categoryLinks",
                title: _unref(globalLabels).categoryHeadline,
                items: _unref(result).categories.results,
                class: "search-section"
              }, null, 8, ["title", "items"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "o-anim-fade-200" }, {
        default: _withCtx(() => [
          (_unref(showProducts))
            ? (_openBlock(), _createBlock(SearchResultProducts, {
                key: "products",
                title: _unref(globalLabels).productHeadline,
                products: _unref(result).products.results[0].results,
                class: "search-section"
              }, null, 8, ["title", "products"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "o-anim-fade-200" }, {
        default: _withCtx(() => [
          (_unref(showContentLinks))
            ? (_openBlock(), _createBlock(SearchResultItems, {
                key: "contentLinks",
                title: _unref(globalLabels).informationHeadline,
                items: _unref(result).content.results,
                class: "search-section"
              }, null, 8, ["title", "items"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { "enter-active-class": "animated fadeIn u-anim-delay-200 u-anim-dur-200" }, {
        default: _withCtx(() => [
          (_unref(showQuickLinks))
            ? (_openBlock(), _createBlock(SearchQuickLinks, {
                key: "quickLinks",
                title: _unref(globalLabels).quickLinksHeadline,
                class: "search-section"
              }, null, 8, ["title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "o-anim-fade-200" }, {
      default: _withCtx(() => [
        (_unref(showShowAllResultsButton))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(RouterLinkConditional, {
                to: _unref(searchPageLink),
                class: "c-button c-button--secondary-dark w-full sm:w-3/5 md:w-2/5 lg:w-1/4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(globalLabels).showAll), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { "enter-active-class": "animated fadeIn u-anim-delay-200 u-anim-dur-200" }, {
      default: _withCtx(() => [
        (_unref(showNoResultText))
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(globalLabels).noResultsForSearchTerm, { searchTerm: _unref(term) })), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})